import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { db } from '../Firebase';

export const mockBranches = [
  {
    id: 'HO',
    name: 'Head Office (Sangli)',
    manager: 'Shri. Ravindra M. Bhosale',
    phone: '+91 2162 234567',
    email: 'ho@sahyadriurban.com',
    hours: '10:00 AM - 5:00 PM',
    address: 'Sahyadri Bhavan, Cooperative Plaza, Sangli - 415001',
    ifsc: 'ICIC0000007',
    code: 'SHYD001',
    hasAtm: true
  },
  {
    id: 'KRD',
    name: 'Sangli Branch',
    manager: 'Shri. Sanjay S. Patil',
    phone: '+91 2164 221234',
    email: 'sangli@sahyadriurban.com',
    hours: '10:00 AM - 5:00 PM',
    address: 'Near S.T. Stand, Main Road, Sangli - 415110',
    ifsc: 'ICIC0000007',
    code: 'SHYD002',
    hasAtm: true
  },
  {
    id: 'KLP',
    name: 'Kolhapur Branch',
    manager: 'Smt. Smita A. Desai',
    phone: '+91 231 2654321',
    email: 'kolhapur@sahyadriurban.com',
    hours: '10:00 AM - 5:00 PM',
    address: 'Rajarampuri 2nd Lane, Kolhapur - 416008',
    ifsc: 'ICIC0000007',
    code: 'SHYD003',
    hasAtm: true
  },
  {
    id: 'PUN',
    name: 'Pune Kothrud Branch',
    manager: 'Shri. Abhijit D. Joshi',
    phone: '+91 20 25445678',
    email: 'pune.kothrud@sahyadriurban.com',
    hours: '10:00 AM - 5:00 PM',
    address: 'Ideal Colony, Paud Road, Kothrud, Pune - 411038',
    ifsc: 'ICIC0000007',
    code: 'SHYD004',
    hasAtm: true
  },
  {
    id: 'MUM',
    name: 'Mumbai Fort Branch',
    manager: 'Shri. Milind S. Rane',
    phone: '+91 22 22667890',
    email: 'mumbai.fort@sahyadriurban.com',
    hours: '10:00 AM - 5:00 PM',
    address: 'Cooperative House, Fort, Mumbai - 400001',
    ifsc: 'ICIC0000007',
    code: 'SHYD005',
    hasAtm: false
  }
];

export const defaultChairmanData = {
  id: 'chairman',
  name: 'Shri. Balasaheb A. Bhosale',
  role: 'Chairman, Sahyadri Board',
  title: '"Steering Sahyadri with Community Trust"',
  message: '"Our journey in cooperative banking is rooted in mutual support. While standard commercial banks focus on corporate balance sheets, Sahyadri is proud to focus on local farmers, cottage shops, and middle-income deposits. Over the next five years, we are aggressively investing in cyber safety networks to make sure our digital savings portals are as fortified as our traditional physical security frameworks."',
  imageUrl: ''
};

export const defaultCeoData = {
  id: 'ceo',
  name: 'Shri. Hanmant R. Ghadge',
  role: 'CEO / General Manager',
  title: '"Innovating Core Banking Operations"',
  message: '"Digitalization is not just for mega banks. At Sahyadri, we believe our members deserve high-performance UPI transactions, real-time balance auditing, and instant online loan processing. We have successfully automated our internal credit processing engine, making loan verification twice as fast without compromising compliance audit trails."',
  imageUrl: ''
};

export const mockBoardOfDirectors = [
  {
    id: 'dir_1',
    name: 'Shri. Balasaheb A. Bhosale',
    role: 'Chairman',
    description: 'Ex-Cooperative Leader with 35+ years of banking experience. Guiding Sahyadri toward digital growth.',
    imageUrl: '',
    order: 1
  },
  {
    id: 'dir_2',
    name: 'Shri. Dnyaneshwar P. Patil',
    role: 'Vice Chairman',
    description: 'Agricultural Economist and social activist. Focusing on rural credit accessibility.',
    imageUrl: '',
    order: 2
  },
  {
    id: 'dir_3',
    name: 'Smt. Vasundhara R. Mohite',
    role: 'Director (Women Representative)',
    description: 'Promoter of Self Help Groups (SHGs) and women entrepreneurship programs.',
    imageUrl: '',
    order: 3
  },
  {
    id: 'dir_4',
    name: 'Shri. Prabhakar S. Kale',
    role: 'Director (Finance)',
    description: 'Chartered Accountant (FCA). Oversees risk management, audits, and compliance portfolios.',
    imageUrl: '',
    order: 4
  },
  {
    id: 'dir_5',
    name: 'Shri. Hanmant R. Ghadge',
    role: 'General Manager / CEO',
    description: 'Banking software architect with 25 years in operations management. Spearheading digital transformations.',
    imageUrl: '',
    order: 5
  }
];

export const mockNews = [
  {
    id: 'n1',
    title: 'Sahyadri Urban Launches Secure Member Portal',
    summary: 'Members can check account balances, download statement files, and request funds transfer details via the new secure portal.',
    content: 'We are thrilled to announce the launch of our new online Member Portal. Access it directly from our website using your registered credentials. Features include real-time transaction updates, instant transfer requests, deposit/loan status checks, and customer complaint filings.',
    category: 'Announcements',
    date: '2026-06-25',
    isCircular: false
  },
  {
    id: 'n2',
    title: 'Revision of Deposit Interest Rates for Senior Citizens',
    summary: 'Sahyadri Board has revised Fixed Deposit interest rates for senior citizens, offering up to 8.75% interest on 3-year term deposits.',
    content: 'In our quarterly board meeting, it has been resolved to increase interest rates for Senior Citizen members to support them with regular income streams. Effective from July 1st, 2026, Senior Citizens will receive 8.75% per annum on Fixed Deposits with tenures of 3 to 5 years. Standard rates will remain at 8.25% for the general public.',
    category: 'New Schemes',
    date: '2026-06-20',
    isCircular: true
  },
  {
    id: 'n3',
    title: 'Advisory on Cyber Security & Safe Banking Practices',
    summary: 'An important guidelines document issued by RBI and our safety cell on protecting your Member Portal passwords.',
    content: 'Sahyadri Urban Credit Society never asks for your OTP, Username, Password, or ATM Pin over phone calls, SMS, or emails. We advise our members to change their portal credentials regularly, avoid logging in on public Wi-Fi, and monitor statements frequently. Block cards immediately using our helpline if suspicious activity is found.',
    category: 'Cyber Security',
    date: '2026-06-15',
    isCircular: true
  },
  {
    id: 'n4',
    title: 'Support Schemes for Local Farmers during Kharif Season',
    summary: 'Offering low-interest short-term agricultural loans and seed distribution support to our registered farmers.',
    content: 'Continuing our commitment to rural development, Sahyadri Urban is offering Kharif crop loans at special discounted interest rates starting from 7.5% p.a. Farmers can apply at any rural branch with basic soil test papers and Land record certificates. Fast disbursals within 3 working days are guaranteed.',
    category: 'Financial Awareness',
    date: '2026-06-10',
    isCircular: false
  }
];

export const mockNotices = [
  {
    id: 'not_01',
    title: '42nd Annual General Body Meeting (AGM) Notice & Agenda',
    noticeNo: 'SHYD/AGM/2026-27/01',
    category: 'Announcements',
    date: '2026-07-15',
    department: 'Board Administration',
    description: 'Official notice to all voting members regarding the 42nd Annual General Meeting scheduled at Sangli Headquarters on 15th August 2026 at 11:00 AM.',
    pdfUrl: '',
    pdfName: 'AGM_Notice_Agenda_2026_27.pdf',
    fileSize: '420 KB'
  },
  {
    id: 'not_02',
    title: 'Revised Schedule of Locker Rent Charges & Safety Guidelines 2026',
    noticeNo: 'SHYD/OPS/CIR/2026/12',
    category: 'New Schemes',
    date: '2026-07-01',
    department: 'Banking Operations',
    description: 'Updated guidelines on Safe Deposit Locker rental slabs and nominal security fees effective from Q2 2026 across all urban branches.',
    pdfUrl: '',
    pdfName: 'Locker_Charges_Circular_2026.pdf',
    fileSize: '310 KB'
  },
  {
    id: 'not_03',
    title: 'Mandatory Re-KYC Circular for Inactive & High Value Accounts',
    noticeNo: 'SHYD/KYC/NOT/2026/04',
    category: 'Cyber Security',
    date: '2026-06-28',
    department: 'Audit & Compliance',
    description: 'All members with accounts dormant for over 1 year are requested to submit fresh Aadhar and PAN KYC at nearest branch within 30 days.',
    pdfUrl: '',
    pdfName: 'Mandatory_KYC_Update_2026.pdf',
    fileSize: '280 KB'
  },
  {
    id: 'not_04',
    title: 'Financial Literacy & Digital Banking Workshop Schedule',
    noticeNo: 'SHYD/FLW/2026/09',
    category: 'Financial Awareness',
    date: '2026-06-18',
    department: 'Member Development',
    description: 'Schedule for weekly member awareness sessions on UPI safety, mobile banking features, and government interest subvention schemes.',
    pdfUrl: '',
    pdfName: 'Financial_Literacy_Schedule_2026.pdf',
    fileSize: '350 KB'
  }
];

export const mockTestimonials = [
  {
    name: "Shri. Maruti D. Patil",
    role: "Sugarcane Farmer (Sangli)",
    quote: "Sahyadri's crop loans helped me purchase quality seeds and fertilizers on time. Their quick approval process during the agricultural season was a lifesaver. Extremely grateful for their rural focus.",
    rating: 5
  },
  {
    name: "Smt. Priyanka S. Shinde",
    role: "Proprietor, Shinde Garments (Sangli)",
    quote: "Applying for a business loan at other banks took weeks of paperwork. Sahyadri Urban approved my MSME store expansion fund within 4 days. The mobile banking app is also highly convenient for vendors.",
    rating: 5
  },
  {
    name: "Dr. Sandeep K. Joshi",
    role: "General Surgeon (Pune)",
    quote: "I opened multiple Fixed Deposits with Sahyadri because they offer significantly higher returns than commercial banks. Their customer service is prompt and highly professional.",
    rating: 5
  }
];

export const mockCareers = [
  {
    id: 'c1',
    title: 'Branch Manager',
    department: 'Branch Operations',
    location: 'Mumbai Fort Branch',
    experience: '5-8 Years in Retail Banking',
    qualification: 'Graduation / MBA in Banking & Finance',
    vacancies: '2 Posts',
    skills: 'Branch Leadership, Credit Appraisal, NPA Recovery, Team Management, KYC Compliance',
    type: 'Full-Time',
    salary: '₹60,000 - ₹75,000 / month',
    description: 'Responsible for branch business growth, audit compliance, high-value deposit acquisition, loan sanctioning oversight, and staff administration.'
  },
  {
    id: 'c2',
    title: 'Loan Officer (Agricultural & Gold Specialist)',
    department: 'Credit & Loans',
    location: 'Sangli Head Office',
    experience: '2-4 Years in Agri / Retail Lending',
    qualification: 'B.Sc Agriculture / B.Com with Rural Credit Experience',
    vacancies: '3 Posts',
    skills: 'Agricultural Valuation, Land 7/12 Verification, Gold Appraisal, Loan Documentation, CIBIL Check',
    type: 'Full-Time',
    salary: '₹35,000 - ₹45,000 / month',
    description: 'Assess farm and personal loan applications, inspect gold ornaments, verify land revenue records, conduct field verifications, and manage timely repayments.'
  },
  {
    id: 'c3',
    title: 'Customer Relations Executive / Cashier',
    department: 'Customer Service',
    location: 'Pune Kothrud Branch',
    experience: '1-3 Years in Front Office',
    qualification: 'Any Graduate (B.Com / B.A / B.Sc / BBA)',
    vacancies: '4 Posts',
    skills: 'Cash Handling, Net Banking Onboarding, Communication, Tally/Banking ERP, Customer Assistance',
    type: 'Full-Time',
    salary: '₹22,000 - ₹28,000 / month',
    description: 'Handle counter deposits and withdrawals, assist members with locker operations, onboard members on mobile banking app, and resolve service queries.'
  },
  {
    id: 'c4',
    title: 'IT & Cyber Security Associate',
    department: 'IT & Digital Banking',
    location: 'Sangli Head Office',
    experience: '2-5 Years in Banking IT Infrastructure',
    qualification: 'B.E. / B.Tech / MCA in Computer Science / IT',
    vacancies: '2 Posts',
    skills: 'CBS Systems, Network Security, Firewall Config, Database Backup, UPI Gateway Integrations',
    type: 'Full-Time',
    salary: '₹40,000 - ₹55,000 / month',
    description: 'Maintain server uptime, ensure Core Banking Software (CBS) security protocols, manage periodic database backups, and troubleshoot branch network links.'
  }
];

export const mockCareerApplications = [
  {
    id: 'app_172001',
    applicationId: 'app_172001',
    jobTitle: 'Branch Manager',
    fullName: 'Amol R. Shinde',
    email: 'amol.shinde@example.com',
    phone: '9876543210',
    experience: '6 Years in Cooperative Banking',
    qualification: 'MBA in Finance',
    coverNote: 'Experienced banking professional with strong knowledge of credit societies, RBI audit compliance, and deposit mobilization in western Maharashtra.',
    status: 'Applied',
    createdAt: '2026-07-20 11:30 AM',
    resumeUrl: '',
    resumeName: 'Amol_Shinde_Resume.pdf'
  },
  {
    id: 'app_172002',
    applicationId: 'app_172002',
    jobTitle: 'Loan Officer (Agricultural & Gold Specialist)',
    fullName: 'Pooja V. Kulkarni',
    email: 'pooja.kulkarni@example.com',
    phone: '9822334455',
    experience: '3 Years Agri Lending',
    qualification: 'B.Sc Agriculture',
    coverNote: 'Have worked extensively in Sangli and Kolhapur rural zones evaluating sugarcane and horticulture farmer credit applications.',
    status: 'Followed Up',
    createdAt: '2026-07-22 03:45 PM',
    resumeUrl: '',
    resumeName: 'Pooja_Kulkarni_CV.pdf'
  },
  {
    id: 'app_172003',
    applicationId: 'app_172003',
    jobTitle: 'Customer Relations Executive / Cashier',
    fullName: 'Siddharth M. Patil',
    email: 'siddharth.patil@example.com',
    phone: '9988776655',
    experience: '2 Years in Bank Teller Operations',
    qualification: 'B.Com (Banking & Insurance)',
    coverNote: 'Skilled in computerized counter cash operations, daily balancing, KYC verification, and customer assistance.',
    status: 'Applied',
    createdAt: '2026-07-25 10:15 AM',
    resumeUrl: '',
    resumeName: 'Siddharth_Patil_Profile.pdf'
  }
];

// Seeding function
export async function seedAllData() {
  try {
    // Check if leadership needs seeding
    try {
      const chairSnap = await getDocs(collection(db, 'leadership'));
      if (chairSnap.empty) {
        await setDoc(doc(db, 'leadership', 'chairman'), defaultChairmanData);
        await setDoc(doc(db, 'leadership', 'ceo'), defaultCeoData);
      }
    } catch (e) {}

    // Check if directors need seeding
    try {
      const dirSnap = await getDocs(collection(db, 'directors'));
      if (dirSnap.empty) {
        for (const dir of mockBoardOfDirectors) {
          await setDoc(doc(db, 'directors', dir.id), dir);
        }
      }
    } catch (e) {}

    // Check if branches already seeded
    const checkRef = collection(db, 'branches');
    const checkSnap = await getDocs(checkRef);
    if (!checkSnap.empty) {
      // Check if notices or careers need seeding
      try {
        const noticesSnap = await getDocs(collection(db, 'notices'));
        if (noticesSnap.empty) {
          for (const not of mockNotices) {
            await setDoc(doc(db, 'notices', not.id), not);
          }
        }
        const appSnap = await getDocs(collection(db, 'career_applications'));
        if (appSnap.empty) {
          for (const app of mockCareerApplications) {
            await setDoc(doc(db, 'career_applications', app.id), app);
          }
        }
      } catch (e) {
        console.warn("Sub-collection seeding check error:", e);
      }
      return;
    }

    console.log("Seeding Database with Sahyadri default data...");

    // Seed Leadership
    await setDoc(doc(db, 'leadership', 'chairman'), defaultChairmanData);
    await setDoc(doc(db, 'leadership', 'ceo'), defaultCeoData);

    // Seed Directors
    for (const dir of mockBoardOfDirectors) {
      await setDoc(doc(db, 'directors', dir.id), dir);
    }

    // Seed Branches
    for (const br of mockBranches) {
      await setDoc(doc(db, 'branches', br.id), br);
    }

    // Seed News & Circulars
    for (const nw of mockNews) {
      await setDoc(doc(db, 'news', nw.id), nw);
    }

    // Seed PDF Notices
    for (const not of mockNotices) {
      await setDoc(doc(db, 'notices', not.id), not);
    }

    // Seed Careers
    for (const cr of mockCareers) {
      await setDoc(doc(db, 'careers', cr.id), cr);
    }

    // Seed Career Applications
    for (const app of mockCareerApplications) {
      await setDoc(doc(db, 'career_applications', app.id), app);
    }

    console.log("Database seeded successfully!");
  } catch (error) {
    console.warn("Firestore seeding failed (might be offline or rule block), local fallback active:", error);
  }
}
